"use client";
import { createContext as e, useContext as o } from "react";
const n = e(void 0), s = () => {
  const t = o(n);
  return t === void 0 ? {} : t;
};
export {
  n as TabContext,
  s as useTabContext
};
